<template>
  <div>
    <div v-if="displayType === emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON">
      <img v-if="materialType === emkt.MATERIAL_TYPE.CELL" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/目的细胞.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.SAMPLE" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/样本.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.ANTIBODY" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/抗体.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.MEDICINE" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/药物.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.KIT" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/试剂盒.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.VIRUS" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/病毒.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.PLASMID" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/质粒.svg'"/>
      <img v-else-if="materialType === emkt.MATERIAL_TYPE.PRIMER" class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/引物.svg'"/>
      <img v-else class="sample-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/其它.svg'"/>
    </div>
    <div v-if="displayType === emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE">
      <div v-if="displayStatusName === '待寄出'" class="mod5" style="background: rgba(255, 148, 0, 0.15);">
        <span class="txt2" style="color: rgba(255, 148, 0, 1);">{{ displayStatusName }}</span>
      </div>
      <div v-else-if="displayStatusName === '已寄出'" class="mod5" style="background: rgba(254, 101, 77, 0.15);">
        <span class="txt2" style="color: rgba(254, 101, 77, 1);">{{ displayStatusName }}</span>
      </div>
      <div v-else-if="displayStatusName === '已到达' || displayStatusName === '已到齐'" class="mod5" style="background: #EAF7F0;">
        <span class="txt2" style="color: #67C08C;">{{ displayStatusName }}</span>
      </div>
      <div v-else class="mod5" style="background: rgba(255, 148, 0, 0.15);">
        <span class="txt2" style="color: rgba(255, 148, 0, 1);">{{ displayStatusName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DisplayIconAndStatus',
    props: {
      displayStatusName: {
        type: String,
        default: ''
      },
      materialType: {
        type: Number
      },
      displayType: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style scoped>
  .txt2 {
    width: 37px;
    height: 14px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(254, 101, 77, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 14px;
    text-align: center;
    margin: 0px 2px 1px 3px;
  }

  .mod5 {
    align-self: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    height: 15px;
    border-radius: 7.5px 7.5px 7.5px 7.5px;
    margin-top: 3px;
    width: 42px;
    align-items: center;
  }

  .sample-icon {
    width: 29px;
    height: 29px;
  }
</style>



// WEBPACK FOOTER //
// DisplayIconAndStatus.vue?c1b3b918